import axios from 'axios';

export function unsubscribe(data: { email: string }) {
  return axios.post(`${window.apiBase}/public/unsubscribe`, data).then(response => {
    return response.data;
  });
}
